export default {
    getTagsFromInCache(state) {
        return state.tags;
    },
    getLocationinfoToLoad(state){
        return Object.assign({}, state.loadPageInfo) 
    },
    getPathLocationInfoToLoad(state){
        return  state.loadPathInfo;
     },
};
